import React from 'react';

import {transparentize} from 'polished';
import ReactTooltip, {TooltipProps} from 'react-tooltip';
import styled from 'styled-components';

import {colors, font} from 'theme';

interface Props extends Partial<TooltipProps> {
    backgroundColor?: string;
    textColor?: string;
}

const TooltipRoot = ({
    effect = 'solid',
    place = 'right',
    backgroundColor = transparentize(0.7, colors.black),
    textColor = colors.white,
    children,
    ...otherProps
}: Props) => (
    <ReactTooltip
        effect={effect}
        place={place}
        backgroundColor={backgroundColor}
        textColor={textColor}
        {...(otherProps.id && {id: otherProps.id})}
        {...otherProps}
    >
        {children}
    </ReactTooltip>
);

export const Tooltip = styled(TooltipRoot)<{additionalStyles?: string}>`
    font-family: ${font.family.primary};
    text-align: center;

    ${(p) => p.additionalStyles ?? ''};
`;
